module.exports = __webpack_public_path__ + "static/media/Strength.fff82c88.svg";